import { render, staticRenderFns } from "./BusPlace.vue?vue&type=template&id=a3af3c8c&scoped=true&"
import script from "./BusPlace.vue?vue&type=script&lang=js&"
export * from "./BusPlace.vue?vue&type=script&lang=js&"
import style0 from "./BusPlace.vue?vue&type=style&index=0&id=a3af3c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3af3c8c",
  null
  
)

component.options.__file = "BusPlace.vue"
export default component.exports